import React from 'react';

function Footer(){
    return(
    
        <div className="paper border footer" >
            <a href="https://github.com/NGDino" target="_blank" id="footerLink"><span className="iconify" data-icon="ant-design:github-outlined" data-inline="false"></span></a>
            <a href="https://www.linkedin.com/in/neildino/" target="_blank" id="footerLink"><span className="iconify" data-icon="openmoji:linkedin" data-inline="false"></span></a>
        </div>
    )
}

export default Footer;